const MerchantTypeAndCuisineForm = ({}) => {
	return <div>MerchantTypeAndCuisineForm</div>;
};
export default MerchantTypeAndCuisineForm;
